var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDictionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.661,
    height: 15.826,
    viewBox: "105 201.25 12.661 15.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.067 215.098a.593.593 0 0 0 .594-.593V203.03c0-.982-.799-1.78-1.78-1.78h-9.1c-.982 0-1.781.798-1.781 1.78v12.265c0 .982.799 1.78 1.78 1.78h10.287a.593.593 0 1 0 0-1.186H106.78a.594.594 0 0 1-.593-.594v-.198h10.88Zm-8.308-9.891h5.143a.593.593 0 1 1 0 1.187h-5.143a.593.593 0 1 1 0-1.187Z",
    fill: "#8c919a",
    fillRule: "evenodd",
    "data-name": "icons8-book"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionary);
export default __webpack_public_path__ + "static/media/dictionary.1bff455ec35df90aff6c0f3853c0445e.svg";
export { ForwardRef as ReactComponent };